import { render, staticRenderFns } from "./Credential.vue?vue&type=template&id=52f8be8d&scoped=true"
import script from "./Credential.vue?vue&type=script&lang=js"
export * from "./Credential.vue?vue&type=script&lang=js"
import style0 from "./Credential.vue?vue&type=style&index=0&id=52f8be8d&prod&lang=scss&scoped=true"
import style1 from "./Credential.vue?vue&type=style&index=1&id=52f8be8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f8be8d",
  null
  
)

export default component.exports